


export class GLOBALS {

    public static RENDER_CARD: number = 1;
    public static RENDER_VERTICAL: number = 2;
    public static RENDER_SEC_FILLINGS: number = 3;
    public static RENDER_ZONA_DOCS: number = 4;

    public static NO_SELECTED_OPTION: number = -1;

    public static MIN_TO_RENDER_PAGINATION: number = 5;
    public static DATE_FORMAT: string = "YYYY-MM-DD";
    public static API_URL_BASE_NAME: string = "docs-man/v1";

    public static DOC_TYPE_8K: string = "8K";
    public static DOC_TYPE_1Q: string = "1Q";
    public static DOC_TYPE_2Q: string = "2Q";
    public static DOC_TYPE_3Q: string = "3Q";
    public static DOC_TYPE_10K: string = "10K";
    public static DOC_TYPE_PROXY: string = "Proxy";
    public static DOC_TYPE_ANNUAL: string = "AnnualReport";
    public static DOC_TYPE_OTHER: string = "Other";

    public static ID_10K_ADDITIONAL_DOCS_1: number = 14;
    public static ID_10K_ADDITIONAL_DOCS_2: number = 15;

}